<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aYqLUh/tc-custom/9781497605435.jpg?1701348805381" alt="This image is the cover for the book What Entropy Means to Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What Entropy Means to Me
      </h1>
      <p class="bookDescription body article font2">
        <b>Nebula Award Finalist</b><br/><br/> Doctor, watch out! As Dore stood by, he saw the Doctor backing slowly into the corner where he would meet his fate. Initially defending himself with a torch, the Doctor searched frantically for a new method of defense. The crimson mass is lunging forward using long, tentacle-like attachments: what is that thing? Slowly the subhuman blob comes in to focus, and Dore realizes...it's a colossal radish! This is a monster never before wrestled with; what are they going to do? After reading this vegetative tale, you won't look at your garden the same way again. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Alec Effinger
      </h2>
      
      <p class="authorDescription body article">George A. Effinger was born in Cleveland, Ohio, in 1947. He attended Yale University, where an organic chemistry course disabused him of the notion of becoming a doctor. He had the opportunity to meet many of his science fiction idols thanks to his first wife, who was Damon Knight and Kate Wilhelm&rsquo;s babysitter. With their encouragement, he began writing science fiction in 1970. He published at least twenty novels and six collections of short fiction, including <I>When Gravity Fails</I> and <I>The Exile Kiss</I>. He also wrote and published two crime novels, <I>Felicia</I> and <I>Shadow Money</I>. With his Budayeen novels, Effinger helped to found the cyberpunk genre. He was a Hugo and Nebula Award winner and is a favorite among fellow science fiction writers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f1eca20